let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c78H2")).then(() => parcelRequire('jcrK7'));